import { useLocation } from 'react-router';
import { useNavigationStateStore } from './useNavigationStateStore';
import { useEffect, useCallback } from 'react';

export function usePersistentNavigation() {
  const { pathname, search } = useLocation();
  const setSearchParamsForPath = useNavigationStateStore((state) => state.setSearchParamsForPath);
  const getSearchParamsForPathStore = useNavigationStateStore((state) => state.getSearchParamsForPath);

  useEffect(() => {
    setSearchParamsForPath(pathname, search);
  }, [pathname, search, setSearchParamsForPath]);

  const getPersistentSearchParams = useCallback((path: string) => {
    return getSearchParamsForPathStore(path);
  }, [getSearchParamsForPathStore]);

  return { getPersistentSearchParams };
}
